import { types } from "./types";
import UserService from "../../service/userService";
import { CURRENT_ROLE_CUSTOMER_BASED } from "utils/customerBasedConfigs";


export const setUserData = 
  () => async (dispatch) => {
    return new Promise((res,rej)=>{
      let promise, flaggedRestriction;
      try {
        promise = UserService.fetchUser()
      } catch (error) {
        console.log(error);
      }
      promise.then((reponseData) => {
          let jsonData = reponseData && reponseData.data;
          if(jsonData.authorities == null){
            let redirectUrl = `${window.location.origin}/access_denied.html`;
            flaggedRestriction = true;
            window.location.href = redirectUrl;
            return
          }
          let role = jsonData?.authorities[0]?.authority;
          window.userRoleDirect = role;
          window.userNameLoggedIn = jsonData.username;
          window.secureApi = jsonData.secureAPI;
          dispatch({
            type: types.SET_PARAM,
            payload: {userRole:  CURRENT_ROLE_CUSTOMER_BASED()[role] ? CURRENT_ROLE_CUSTOMER_BASED()[role] : role},
          });
          dispatch({
            type: types.SET_REPORT_DATA,
            payload: {user:jsonData},
          });
          dispatch({
            type: types.PARAM_FILTER,
            payload: {"#{loggedin_role}": window.userRoleDirect},
          });
          dispatch({
            type: types.PARAM_FILTER,
            payload: {"#{loggedin_username}": window.userNameLoggedIn},
          });
          res();
        }).catch(e=>{
          if(!flaggedRestriction && !window.location.origin.includes('localhost')){
            window.location.href = "/login";        
          }
          // window.userRoleDirect =  'SYSTEM_ADMIN';
          // dispatch({
          //   type: types.SET_PARAM,
          //   payload: {userRole:  'SYSTEM_ADMIN'},
          // });
          dispatch({
            type: types.PARAM_FILTER,
            payload: {"#{loggedin_role}": 'SYSTEM_ADMIN'},
          });
          dispatch({
            type: types.PARAM_FILTER,
            payload: {"#{loggedin_username}": 'rsarbudeen@inniveinc.com'},
          });
          res();
        });
      
    //  console.log(jsonData.user_role?.[0]?.G_ROLE);
      
    })
  };

